/**
 * Group review items by their currently assigned vendor.
 *
 * An item's `vendor` column may hold a vendor_id, a vendor *name* (legacy rows
 * and the free-text entry both store names), or nothing. Known vendors are
 * matched by id or case-insensitive name against the item's own vendor list
 * first, then the company-wide list; anything else becomes its own
 * `other_<name>` group so a hand-typed vendor still gets a tab.
 */
export const groupItemsBySelectedVendor = (items, allVendors, unassignedLabel) => {
  if (!items || !items.length) return [];

  const groups = new Map();

  for (const item of items) {
    let vendorKey = "unassigned";
    let vendorName = unassignedLabel;
    let vendorId = null;

    const rawVendor = item.vendor;
    const hasVendor =
      rawVendor != null &&
      rawVendor !== "" &&
      String(rawVendor).trim() !== "";

    if (hasVendor) {
      const rawStr = String(rawVendor).trim();

      // 1. Check in item's vendors array
      let matched = item.vendors?.find(
        (v) =>
          String(v.vendor_id) === rawStr ||
          v.vendor_name?.toLowerCase() === rawStr.toLowerCase()
      );

      // 2. Check in top-level vendors list
      if (!matched && allVendors) {
        matched = allVendors.find(
          (v) =>
            String(v.vendor_id) === rawStr ||
            v.vendor_name?.toLowerCase() === rawStr.toLowerCase()
        );
      }

      if (matched) {
        vendorKey = `vendor_${matched.vendor_id}`;
        vendorName = matched.vendor_name;
        vendorId = matched.vendor_id;
      } else {
        // Custom / manual vendor string
        vendorKey = `other_${rawStr.toLowerCase().replace(/\s+/g, "_")}`;
        vendorName = rawStr;
        vendorId = rawStr;
      }
    }

    if (!groups.has(vendorKey)) {
      groups.set(vendorKey, {
        key: vendorKey,
        vendorId,
        vendorName,
        items: [],
      });
    }
    groups.get(vendorKey).items.push(item);
  }

  return Array.from(groups.values()).sort((a, b) =>
    a.vendorName.localeCompare(b.vendorName)
  );
};
